var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 24C18.6272 24 23.9998 18.6274 23.9998 12C23.9998 5.37258 18.6272 0 11.9998 0C5.37234 0 -0.000244141 5.37258 -0.000244141 12C-0.000244141 18.6274 5.37234 24 11.9998 24Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08676 10.803L11.9998 7.89L14.9143 10.8045L16.6093 9.1095L11.9998 4.5L7.39176 9.108L9.08676 10.803ZM4.49976 12L6.19476 10.305L7.88976 12L6.19476 13.695L4.49976 12ZM9.08676 13.197L11.9998 16.11L14.9143 13.1955L16.6093 14.8898L11.9998 19.5L7.39176 14.892L7.38951 14.8898L9.08676 13.197ZM16.1098 12L17.8048 10.305L19.4998 12L17.8048 13.695L16.1098 12ZM13.7188 11.9985H13.7203V12L11.9998 13.7205L10.2815 12.003L10.2785 12L10.2815 11.9977L10.5823 11.6962L10.7285 11.55L11.9998 10.2795L13.7195 11.9992L13.7188 11.9985Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.000244141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.682d41c0b40c15b6ad02899e86e1e50f.svg";
export { ForwardRef as ReactComponent };